/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GrdfConnectionConfig } from '../../models/grdf-connection-config';

export interface GetGrdfConnectionConfigurations$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The uid of the selected GRDF connection configuration
 */
  grdfUid: string;
}

export function getGrdfConnectionConfigurations(http: HttpClient, rootUrl: string, params: GetGrdfConnectionConfigurations$Params, context?: HttpContext): Observable<StrictHttpResponse<GrdfConnectionConfig>> {
  const rb = new RequestBuilder(rootUrl, getGrdfConnectionConfigurations.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('grdfUid', params.grdfUid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GrdfConnectionConfig>;
    })
  );
}

getGrdfConnectionConfigurations.PATH = '/stations/{uid}/grdf/{grdfUid}';
